import React, { useState,useEffect } from 'react';

const InputFieldScoring = (props) => {
    const { config = {}, onChange, className, defaultValue, pattern } = props;
  const [inputValue, setInputValue] = useState(defaultValue ||'');

  const handleChange = (event) => {
    const value = event.target.value;
      setInputValue(value);
      onChange(value,event.target.name)
  };
  
  useEffect(() => {
    if (defaultValue !== undefined) {
        setInputValue(defaultValue);
    }
}, [config, defaultValue]);
  return (
    <div>
      <input
        type="number"
        readOnly={config.readOnly}
        placeholder={config.placeholder}
        className={`form-control form-control-sm border border-1 rounded-0 ${className}`}
        name={config.name || 'field'}
        value={inputValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default InputFieldScoring;
